import React, { useState } from "react";
import { EM2C_CATEGORIES } from "../game/data/em2c-buildings";
import { getColonyCategoryColors } from "../game/data/colonyCategoryColors";

// Read-only color legend. No interaction with game state/placement.
export default function ColonyColorLegend() {
  const [expanded, setExpanded] = useState(false);
  return (
    <div className="absolute top-3 left-3 z-20 pointer-events-auto text-[11px] font-mono text-slate-100">
      <button
        type="button"
        data-testid="colony-color-legend-toggle"
        onClick={() => setExpanded((value) => !value)}
        className="bg-[#101820]/90 border border-white/20 px-3 py-2 text-left shadow-lg hover:border-white/50"
        aria-expanded={expanded}
      >
        <span className="font-bold tracking-widest">BUILDING COLORS</span>
        <span className="ml-2 text-slate-400">{expanded ? "−" : "+"}</span>
      </button>
      {expanded && (
        <div data-testid="colony-color-legend" className="bg-[#101820]/95 border border-white/20 shadow-xl p-3 mt-1 grid grid-cols-2 gap-x-3 gap-y-2 max-w-[320px]">
          {EM2C_CATEGORIES.map((category) => {
            const paint = getColonyCategoryColors(category.id);
            return (
              <div key={category.id} className="flex gap-2 items-center min-w-0">
                <span aria-hidden="true" className="h-3 w-3 shrink-0 border border-white/40" style={{ backgroundColor: paint.body, boxShadow: `inset 0 0 0 2px ${paint.accent}` }} />
                <span className="leading-tight">{paint.label}</span>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
